module.exports = __webpack_public_path__ + "37de805e766e43d448918ed95ccad419.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/dan-gebhardt.jpg
// module id = 662
// module chunks = 0